import { Inject, Injectable } from '@angular/core';
import { ANGULARJS_SERVICE_UPGRADE_TOKENS } from '../angularjs-service-upgrade.enum';
import { BehaviorSubject, Observable } from 'rxjs';
import { IRootScopeService } from 'angular';

@Injectable({
  providedIn: 'root'
})
export class RootScopeService {
  private listeners: { [property: string]: Function } = {};
  private rootScope: BehaviorSubject<{ [property: string]: any }> = new BehaviorSubject({});
  rootScopeObservable: Observable<{ [property: string]: any }> = this.rootScope.asObservable();

  constructor(@Inject(ANGULARJS_SERVICE_UPGRADE_TOKENS.ROOT_SCOPE_TOKEN) private _rootScope: IRootScopeService) {
  }

  updateScope(
    property: string,
    value: any,
    tab: number = 0
  ): void {
    this._rootScope.$broadcast(property, value, tab);
  }

  detectScopeChanges(property: string): void {
    this.listeners[property] = this._rootScope.$on(property, () => {
      this.rootScope.next({ [property]: (this._rootScope as any)?.[property] ?? true });
      this.removeScopeChanges(property);
    });

  }

  unsubscribeFromScopeChanges(properties: string[]){
    for(let prop of properties){
      this.listeners[prop](); 
      delete this.listeners[prop];
    }
  }

  private removeScopeChanges(property: string): void {
    this.rootScope.next({ [property]: false });
  }

  public getRootScope() {
    return this._rootScope;
  }
}
